export default __webpack_public_path__ + "static/media/basketball-net.389b03cb.png";